import { render } from "./ResultsOctagonal.vue?vue&type=template&id=603aaf60&ts=true"
import script from "./ResultsOctagonal.vue?vue&type=script&lang=ts"
export * from "./ResultsOctagonal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/mind.findingyou.co/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__